import { action } from "satcheljs";

export const onInteractionRequiredAuthFailure: () => {} = action("onInteractionRequiredAuthFailure");
